<template>
  <div class="page-container" :style="{ 'color': textColor }">
    <div class="background-layer" :style="{ 'background-image': `url(${backgroundImageUrl})` }"></div>
    
    <!-- 用户区域 -->
    <div class="user-area">
      <div class="user-info-box" v-if="isLoggedIn">
        <div class="user-avatar-wrapper" @click="showDropdown = !showDropdown">
          <el-avatar :size="45" :src="userInfo.face" class="user-avatar" />
        </div>
        <transition name="el-zoom-in-top">
          <div v-if="showDropdown" class="user-dropdown-menu">
            <div class="dropdown-header">
              <el-avatar :size="52" :src="userInfo.face" class="dropdown-avatar" />
              <div class="user-details">
                <h3>{{ userInfo.uname }}</h3>
                <p class="user-id">UID: {{ userInfo.mid }}</p>
                <p class="user-integral">积分: {{ settingData.Integral }}</p>
              </div>
            </div>
            <div class="dropdown-divider"></div>
            <div class="dropdown-item" @click="goTo('points')">
              <el-icon><Coin /></el-icon>
              <span>积分兑换</span>
            </div>
            <div class="dropdown-item" @click="logout2">
              <el-icon><SwitchButton /></el-icon>
              <span>退出登录</span>
            </div>
          </div>
        </transition>
      </div>
      <div class="login-entry" v-else>
        <el-button type="primary" size="small" @click="goToLogin">登录</el-button>
      </div>
    </div>

    <!-- 导航栏 -->
    <nav class="navbar">
      <ul class="nav-list">
        <li class="nav-item" v-for="item in shownNav" :key="item.path" :class="{ 'active': isActive(item.path) }">
          <router-link :to="item.path" :style="{ 'background-color': settingData.Navigationcolor || 'rgba(0, 0, 0, 0.7)' }">
            <el-icon :size="18"><component :is="item.icon" /></el-icon>
            <span>{{ item.name }}</span>
          </router-link>
        </li>
      </ul>
    </nav>

    <!-- 主内容 -->
    <div class="link-integral-container">
      <el-card class="main-card glass-effect" shadow="hover">
        <template #header>
          <div class="header-title">
            <el-icon class="title-icon"><Clock /></el-icon>
            <span>兑换记录</span>
          </div>
        </template>

        <div class="record-table-container">
          <el-table :data="records" border stripe :loading="loading" style="width: 100%" empty-text="暂无兑换记录">
            <el-table-column prop="shopname" label="商品名称" min-width="120" show-overflow-tooltip />
            <el-table-column prop="shopprice" label="消耗积分" width="100" align="center" />
            <el-table-column prop="virtual" label="类型" width="90" align="center">
              <template #default="{ row }">
                <el-tag :type="row.virtual === '1' ? 'primary' : 'success'" size="small">
                  {{ row.virtual === '1' ? '电子礼物' : '实物' }}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="time" label="兑换时间" width="160" align="center" />
            <el-table-column prop="status" label="状态" width="100" align="center">
              <template #default="{ row }">
                <el-tag :type="statusType(row.status)" size="small">
                  {{ statusText(row.status) }}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column label="下载" width="130" align="center">
              <template #default="{ row }">
                <div v-if="row.virtual === '1' && row.status === 'true'">
                  <el-tooltip :content="downloadTip(row)" placement="top">
                    <el-button 
                      type="primary" 
                      size="small" 
                      :icon="Download" 
                      circle
                      :loading="downloadingId === row.id"
                      :disabled="downloadingId === row.id || parseInt(row.download_count) >= 5"
                      @click="handleDownload(row)" />
                  </el-tooltip>
                  <span class="download-count">{{ row.download_count || 0 }}/5</span>
                </div>
                <span v-else-if="row.virtual === '1' && row.status !== 'true'" style="color:#999;font-size:12px">待完成</span>
                <span v-else style="color:#999;font-size:12px">-</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-card>
    </div>

    <!-- 下载弹窗 -->
    <el-dialog v-model="downloadVisible" title="下载文件" width="500px">
      <div class="download-content">
        <p><strong>商品：</strong>{{ downloadItem.shopname }}</p>
        <p><strong>已下载：</strong>{{ downloadItem.download_count || 0 }} / 5 次</p>
        <p v-if="parseInt(downloadItem.download_count) >= 5" style="color: red;">
          下载次数已达上限，无法继续下载！
        </p>
        <div v-else class="file-list">
          <p><strong>可下载文件：</strong></p>
          <div v-for="(file, index) in downloadFiles" :key="index" class="file-item">
            <el-link :href="ASSET_BASE + file" target="_blank" type="primary" :underline="false">
              <el-icon><FolderOpened /></el-icon>
              文件 {{ index + 1 }}
            </el-link>
          </div>
        </div>
      </div>
      <template #footer>
        <el-button @click="downloadVisible = false">关闭</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script setup>
import { ref, reactive, onMounted, computed, onUnmounted } from 'vue';
import { ElMessage } from 'element-plus';
import {
  Clock, User, StarFilled, SwitchButton, Coin, Download, FolderOpened,
  HomeFilled, Collection, Present, Headset, InfoFilled
} from '@element-plus/icons-vue';
import axios from 'axios';
import { useRoute, useRouter } from 'vue-router';
import { ASSET_BASE } from '../../util/assetBase';

const route = useRoute();
const router = useRouter();

const records = ref([]);
const loading = ref(false);
const downloadVisible = ref(false);
const downloadItem = ref({});
const downloadFiles = ref([]);

const isLoggedIn = ref(false);
const showDropdown = ref(false);
const userInfo = reactive({ uname: '', mid: '', face: '' });
const settingData = reactive({
  nickname: '', bottomcolor: '#000000', Navigationcolor: 'rgba(0, 0, 0, 0.7)',
  Integral: 0
});
const backgroundImageUrl = ref('');
const textColor = computed(() => '#fff');

const navItems = [
  { path: '/', name: '首页', icon: HomeFilled },
  { path: '/works', name: '作品', icon: Collection },
  { path: '/points', name: '积分兑换', icon: Coin },
  { path: '/captain', name: '舰长礼物', icon: Present },
  { path: '/songlist', name: '歌单', icon: Headset },
  { path: '/livecalendar', name: '直播日历', icon: 'Calendar' },
  { path: '/about', name: '关于', icon: InfoFilled }
];

// 一场直播记录都还没有的时候，导航里的「直播日历」就不出现（后台录一场，它自己就回来）
const liveCount = ref(0);
// 主人要求：直播日历这一项所有域名都显示（原来是「有直播记录才出现」，
// 结果子域名那几个库是空的，整个入口都看不见了）
const shownNav = computed(() => navItems.slice());
axios.get('/adminapi/live/list?_=' + Date.now()).then((r) => { liveCount.value = Number((r.data && r.data.count) || 0); }).catch(() => {});

const isActive = (path) => route.path === path;

const statusType = (status) => {
  if (status === 'true') return 'success';
  if (status === 'cancel') return 'danger';
  return 'info';
};

const statusText = (status) => {
  if (status === 'true') return '已完成';
  if (status === 'cancel') return '已取消';
  return '处理中';
};

const downloadTip = (row) => {
  const count = parseInt(row.download_count) || 0;
  if (count >= 5) return '下载次数已达上限(5次)';
  return `还可下载${5 - count}次`;
};

const goTo = (path) => {
  router.push('/' + path);
};

const goToLogin = () => router.push('/user/login');

const logout2 = () => {
  localStorage.removeItem('userInfo');
  isLoggedIn.value = false;
  showDropdown.value = false;
  router.push('/');
  ElMessage.success('已退出登录');
};

const checkLoginStatus = () => {
  const saved = localStorage.getItem('userInfo');
  if (saved) {
    try {
      const parsed = JSON.parse(saved);
      if (parsed.mid) {
        Object.assign(userInfo, parsed);
        isLoggedIn.value = true;
      }
    } catch (e) { localStorage.removeItem('userInfo'); }
  }
};

const getRecords = async () => {
  if (!userInfo.mid) return;
  loading.value = true;
  try {
    const res = await axios.get('/adminapi/user/ExchangeRecord/list', {
      params: { uid: userInfo.mid }
    });
    records.value = res.data.results || [];
  } catch (e) {
    console.error('获取兑换记录失败:', e);
  } finally {
    loading.value = false;
  }
};

// 下载额度是每次请求都会消耗的，必须防连点（慢网双击会白扣 2 次）
const downloadingId = ref('');

const handleDownload = async (row) => {
  if (downloadingId.value) return;
  downloadingId.value = row.id;
  downloadItem.value = row;
  try {
    const res = await axios.post('/adminapi/user/ExchangeRecord/download', {
      recordId: row.id,
      uid: userInfo.mid
    });
    if (res.data.code === 200) {
      downloadFiles.value = res.data.data.files || [];
      row.download_count = String(res.data.data.downloadCount);
      downloadVisible.value = true;
      ElMessage.success(`获取下载地址成功，剩余${res.data.data.remaining}次`);
    } else if (res.data.code === 201) {
      ElMessage.error('下载次数已达上限（最多5次）');
    } else if (res.data.code === 202) {
      ElMessage.warning('该兑换尚未完成，无法下载');
    } else {
      ElMessage.error(res.data.message || '获取失败');
    }
  } catch (e) {
    console.error('下载失败:', e);
    ElMessage.error('获取下载地址失败');
  } finally {
    downloadingId.value = '';
  }
};

// 点击空白区域收起用户下拉（具名函数，注册/注销保持同一引用，避免监听器泄漏）
const handleClickOutside = (e) => {
  const area = document.querySelector('.user-area');
  if (area && !area.contains(e.target)) showDropdown.value = false;
};

onMounted(() => {
  checkLoginStatus();
  if (isLoggedIn.value) getRecords();
  document.addEventListener('click', handleClickOutside);
});

onUnmounted(() => {
  document.removeEventListener('click', handleClickOutside);
});
</script>

<style lang="scss" scoped>
.page-container {
  min-height: 100vh;
  padding: 20px;
  position: relative;
  background: #1a1a2e;
}
.background-layer {
  position: fixed; top: 0; left: 0; right: 0; bottom: 0;
  background-size: cover; background-position: center;
  z-index: -1; opacity: 0.3;
}
.user-area {
  position: absolute; top: 20px; right: 20px; z-index: 100;
  .user-info-box { position: relative;
    .user-avatar-wrapper { cursor: pointer;
      .user-avatar { border: 2px solid rgba(255,255,255,0.8); box-shadow: 0 4px 12px rgba(0,0,0,0.15); }
    }
    .user-dropdown-menu {
      position: absolute; top: 60px; right: 0; width: 260px;
      background: rgba(255,255,255,0.95); border-radius: 12px;
      box-shadow: 0 8px 32px rgba(0,0,0,0.2); overflow: hidden; z-index: 200;
      .dropdown-header { padding: 20px; display: flex; background: linear-gradient(135deg, #f5f7fa, #e4e7eb);
        .dropdown-avatar { margin-right: 15px; border: 3px solid white; }
        .user-details {
          h3 { margin: 0 0 5px; color: #333; font-size: 16px; }
          .user-id { margin: 0; color: #666; font-size: 12px; }
          .user-integral { margin: 5px 0 0; color: #e6a23c; font-size: 14px; font-weight: bold; }
        }
      }
      .dropdown-divider { height: 1px; background: rgba(238,238,238,0.5); margin: 0 15px; }
      .dropdown-item {
        padding: 12px 20px; display: flex; align-items: center; cursor: pointer; color: #666;
        &:hover { background: rgba(245,247,250,0.8); color: #ff4081; }
        .el-icon { margin-right: 10px; font-size: 16px; }
      }
    }
  }
}
.login-entry .login-button { background: linear-gradient(135deg, #6a11cb, #2575fc); border: none; border-radius: 20px; }
.navbar {
  position: relative; z-index: 1; margin-bottom: 30px;
  .nav-list { display: flex; justify-content: center; list-style: none; padding: 0; gap: 10px; flex-wrap: wrap; }
  .nav-item a {
    color: white; text-decoration: none; font-size: 15px; padding: 10px 18px;
    border-radius: 20px; display: flex; align-items: center; border: 1px solid rgba(255,255,255,0.18);
    &:hover { opacity: 0.9; transform: translateY(-2px); }
    &.router-link-active { box-shadow: 0 0 10px rgba(255,255,255,0.5); font-weight: bold; }
    .nav-icon { margin-right: 8px; }
  }
}
.link-integral-container {
  max-width: 1000px; margin: 0 auto; padding: 20px;
  .main-card { border-radius: 16px !important; }
  .header-title { display: flex; align-items: center; font-size: 18px; color: #fff; .title-icon { margin-right: 10px; } }
}
.record-table-container { margin-top: 16px; }
.download-count { font-size: 11px; color: #999; margin-left: 4px; display: inline-block; }
.download-content {
  p { margin: 8px 0; }
  .file-list { margin-top: 12px; }
  .file-item { margin: 4px 0; padding: 4px 0; }
}
.glass-effect {
  backdrop-filter: blur(8px); border: 1px solid rgba(255,255,255,0.18) !important;
  box-shadow: 0 8px 32px rgba(0,0,0,0.1) !important; background: rgba(255,255,255,0.85) !important;
}
</style>
